import {
  ButtonLink,
  Heading,
  IconShare,
  Inline,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import { shareInsightsReportEmailHref } from '../resources/shareInsightsReportEmailLink';

export const Success = () => (
  <Stack space="medium">
    <Heading level="2" component="h1">
      Thanks for signing up!
    </Heading>

    <Text>
      Keep an eye on your inbox for all the latest insights and updates from
      SEEK Business including:
    </Text>
    <List>
      <Text>
        Trend Tracking: Access past and emerging industry trends, state-by-state
        insights, and price trends.
      </Text>
      <Text>
        Expert Analysis: Understand how trends impact the economy and Australian
        SMEs.
      </Text>
      <Text>
        Actionable insights: Understand the implications of trends on your
        business and make informed decisions.
      </Text>
    </List>

    <Inline space="none">
      <ButtonLink
        data={{ 'data-attribute': 'share-marketplace-insights-report' }}
        variant="solid"
        href={shareInsightsReportEmailHref}
      >
        Share <IconShare />
      </ButtonLink>
    </Inline>
  </Stack>
);
